import { render, staticRenderFns } from "./life-card-bussiness.vue?vue&type=template&id=b693abaa&scoped=true&lang=pug&"
import script from "./life-card-bussiness.vue?vue&type=script&lang=js&"
export * from "./life-card-bussiness.vue?vue&type=script&lang=js&"
import style0 from "./life-card-bussiness.vue?vue&type=style&index=0&id=b693abaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b693abaa",
  null
  
)

export default component.exports